// Copyright ©️ 2026 eVolve MEP, LLC

import type { EvolveApiRoute } from '@evolvemep/api-ts';
import { Flex, Text } from '@mantine/core';
import type { CustomCellRendererProps } from 'ag-grid-react';

import type { GroupingSettings } from 'helpers/ag-grid/Grouping/createGridGrouping';
import { isNotNil } from 'helpers/isNotNil';

type Props<TRoute extends EvolveApiRoute<'GET_PAGINATED'>, GData extends { entireCount?: number }> = Pick<
  CustomCellRendererProps<GData>,
  'data' | 'api'
> &
  GroupingSettings<TRoute, GData>;

export const GroupRowRenderer = <
  TRoute extends EvolveApiRoute<'GET_PAGINATED'>,
  GData extends { entireCount?: number },
>({
  data,
  getGroupLabel,
  padding,
}: Props<TRoute, GData>) => {
  if (!data) return null;
  const label = getGroupLabel(data);
  return (
    <Flex pl={padding} fw={500} fz="sm" align="center" h="100%" gap="xs">
      {label}
      {isNotNil(data.entireCount) && isNotNil(label) && <Text c="dimmed">({data.entireCount})</Text>}
    </Flex>
  );
};
